import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PopupExclusiveDealsComponent } from './popup-exclusive-deals.component';
import { SubmitedModalModule } from '../../shared/submited-modal/submited-modal.module';

@NgModule({
  declarations: [PopupExclusiveDealsComponent],
  imports: [CommonModule, ReactiveFormsModule, RouterModule, SubmitedModalModule],
  exports: [PopupExclusiveDealsComponent],
})
export class PopupExclusiveDealsModule {}
